<template>
  <div class="wallet-form">
    <div class="row">
      <input
        v-model="name"
        type="text"
        placeholder="Wallet name (optional)"
        @keyup.enter.stop.prevent="submit"
      />
    </div>

    <div class="row actions">
      <button class="primary-btn" :disabled="busy" @click="submit">
        {{ busy ? 'Creating…' : 'Create wallet' }}
      </button>
      <button class="ghost-btn" type="button" :disabled="busy" @click="onCancel">
        Cancel
      </button>
    </div>

    <div v-if="error" class="error">{{ error }}</div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  busy: { type: Boolean, default: false },
  error: { type: String, default: '' },
  initialName: { type: String, default: '' },
})

const emit = defineEmits(['submit', 'cancel'])

const name = ref(props.initialName || '')

watch(
  () => props.initialName,
  (v) => { name.value = v || '' }
)

function submit() {
  if (props.busy) return
  emit('submit', (name.value || '').trim())
}

function onCancel() {
  if (props.busy) return
  name.value = ''
  emit('cancel')
}
</script>

<style scoped>
.wallet-form {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 6px;
  background: #141414;
  border: 1px solid #222;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wallet-form .row {
  display: flex;
}

.wallet-form input {
  width: 100%;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #333;
  background: #0b0b0b;
  color: #eee;
  font-size: 12px;
}

.wallet-form input::placeholder {
  color: #555;
}

.wallet-form .row.actions {
  justify-content: flex-end;
  gap: 6px;
}

.primary-btn,
.ghost-btn {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #333;
  font-size: 12px;
  cursor: pointer;
}

.primary-btn {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}
.primary-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.ghost-btn {
  background: transparent;
  color: #aaa;
}

.ghost-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.primary-btn:hover:enabled {
  filter: brightness(1.05);
}

.ghost-btn:hover:enabled {
  background: #1a1a1a;
}

.error {
  margin-top: 4px;
  padding: 4px 6px;
  border-radius: 4px;
  background: #2a1111;
  border: 1px solid #4a1f1f;
  color: #ffaaaa;
  font-size: 11px;
}
</style>
